import { defineStore } from 'pinia';

export type LocationEntry = { Value: string, Label: string };
export type LocationRegion = 'locationPlDl' | 'locationPlKp' | 'locationPlLbl' | 'locationPlLbs' | 'locationPlLd' | 'locationPlMp' | 'locationPlMz' | 'locationPlOp' | 'locationPlPk' | 'locationPlPdl' | 'locationPlPm' | 'locationPlSl' | 'locationPlSw' | 'locationPlWm' | 'locationPlWp' | 'locationPlZp';
export type LocationCountry = 'locationPl' | 'locationDe' | 'locationRus' | 'locationSk' | 'locationCz' | 'locationGb' | 'locationIrl' | 'locationAfg' | 'locationAl' | 'locationAnd' | 'locationAs' | 'locationA' | 'locationAz' | 'locationB' | 'locationBy' | 'locationBih' | 'locationBg' | 'locationChn' | 'locationHr' | 'locationCy' | 'locationMne' | 'locationCz' | 'locationDk' | 'locationEst' | 'locationFin' | 'locationF' | 'locationGr' | 'locationGe' | 'locationE' | 'locationNl' | 'locationInd' | 'locationIrq' | 'locationIr' | 'locationIrl' | 'locationIs' | 'locationCan' | 'locationKz' | 'locationKgz' | 'locationFl' | 'locationLt' | 'locationL' | 'locationLv' | 'locationMk' | 'locationM' | 'locationMa' | 'locationMd' | 'locationMc' | 'locationMn' | 'locationDe' | 'locationN' | 'locationSy' | 'locationP' | 'locationPl' | 'locationRus' | 'locationRo' | 'locationSrb' | 'locationSk' | 'locationSlo' | 'locationUsa' | 'locationSyr' | 'locationCh' | 'locationS' | 'locationTr' | 'locationTm' | 'locationUa' | 'locationUz' | 'locationH' | 'locationGb' | 'locationI';

// eslint-disable-next-line import/prefer-default-export
export const useLocationStore = defineStore({
	id: 'location',
	state: () => ({
		countries: [
			{ Value: 'locationPl', Label: 'Polska' },
			{ Value: 'locationDe', Label: 'Niemcy' },
			{ Value: 'locationRus', Label: 'Rosja' },
			{ Value: 'locationSk', Label: 'Słowacja' },
			{ Value: 'locationCz', Label: 'Czechy' },
			{ Value: 'locationGb', Label: 'Wielka Brytania' },
			{ Value: 'locationIrl', Label: 'Irlandia' },
			{ Value: 'locationAfg', Label: 'Afganistan' },
			{ Value: 'locationAl', Label: 'Albania' },
			{ Value: 'locationAnd', Label: 'Andora' },
			{ Value: 'locationAs', Label: 'Arabia Saudyjska' },
			{ Value: 'locationA', Label: 'Austria' },
			{ Value: 'locationAz', Label: 'Azerbejdżan' },
			{ Value: 'locationB', Label: 'Belgia' },
			{ Value: 'locationBy', Label: 'Białoruś' },
			{ Value: 'locationBih', Label: 'Bośnia i Hercegowina' },
			{ Value: 'locationBg', Label: 'Bułgaria' },
			{ Value: 'locationChn', Label: 'Chiny' },
			{ Value: 'locationHr', Label: 'Chorwacja' },
			{ Value: 'locationCy', Label: 'Cypr' },
			{ Value: 'locationMne', Label: 'Czarnogóra' },
			{ Value: 'locationCz', Label: 'Czechy' },
			{ Value: 'locationDk', Label: 'Dania' },
			{ Value: 'locationEst', Label: 'Estonia' },
			{ Value: 'locationFin', Label: 'Finlandia' },
			{ Value: 'locationF', Label: 'Francja' },
			{ Value: 'locationGr', Label: 'Grecja' },
			{ Value: 'locationGe', Label: 'Gruzja' },
			{ Value: 'locationE', Label: 'Hiszpania' },
			{ Value: 'locationNl', Label: 'Holandia' },
			{ Value: 'locationInd', Label: 'Indie' },
			{ Value: 'locationIrq', Label: 'Irak' },
			{ Value: 'locationIr', Label: 'Iran' },
			{ Value: 'locationIrl', Label: 'Irlandia' },
			{ Value: 'locationIs', Label: 'Islandia' },
			{ Value: 'locationCan', Label: 'Kanada' },
			{ Value: 'locationKz', Label: 'Kazachstan' },
			{ Value: 'locationKgz', Label: 'Kirgistan' },
			{ Value: 'locationFl', Label: 'Liechtenstein' },
			{ Value: 'locationLt', Label: 'Litwa' },
			{ Value: 'locationL', Label: 'Luksemburg' },
			{ Value: 'locationLv', Label: 'Łotwa' },
			{ Value: 'locationMk', Label: 'Macedonia' },
			{ Value: 'locationM', Label: 'Malta' },
			{ Value: 'locationMa', Label: 'Maroko' },
			{ Value: 'locationMd', Label: 'Mołdawia' },
			{ Value: 'locationMc', Label: 'Monako' },
			{ Value: 'locationMn', Label: 'Mongolia' },
			{ Value: 'locationDe', Label: 'Niemcy' },
			{ Value: 'locationN', Label: 'Norwegia' },
			{ Value: 'locationSy', Label: 'Palestyna' },
			{ Value: 'locationP', Label: 'Portugalia' },
			{ Value: 'locationPl', Label: 'Polska' },
			{ Value: 'locationRus', Label: 'Rosja' },
			{ Value: 'locationRo', Label: 'Rumunia' },
			{ Value: 'locationSrb', Label: 'Serbia' },
			{ Value: 'locationSk', Label: 'Słowacja' },
			{ Value: 'locationSlo', Label: 'Słowenia' },
			{ Value: 'locationUsa', Label: 'Stany Zjednoczone' },
			{ Value: 'locationSyr', Label: 'Syria' },
			{ Value: 'locationCh', Label: 'Szwajcaria' },
			{ Value: 'locationS', Label: 'Szwecja' },
			{ Value: 'locationTr', Label: 'Turcja' },
			{ Value: 'locationTm', Label: 'Turkmenistan' },
			{ Value: 'locationUa', Label: 'Ukraina' },
			{ Value: 'locationUz', Label: 'Uzbekistan' },
			{ Value: 'locationH', Label: 'Węgry' },
			{ Value: 'locationGb', Label: 'Wielka Brytania' },
			{ Value: 'locationI', Label: 'Włochy' },
		],
		poland: [
			{ Value: 'locationPlDl', Label: 'Dolnośląskie' },
			{ Value: 'locationPlKp', Label: 'Kujawsko-pomorskie' },
			{ Value: 'locationPlLbl', Label: 'Lubelskie' },
			{ Value: 'locationPlLbs', Label: 'Lubuskie' },
			{ Value: 'locationPlLd', Label: 'Łódzkie' },
			{ Value: 'locationPlMp', Label: 'Małopolskie' },
			{ Value: 'locationPlMz', Label: 'Mazowieckie' },
			{ Value: 'locationPlOp', Label: 'Opolskie' },
			{ Value: 'locationPlPk', Label: 'Podkarpackie' },
			{ Value: 'locationPlPdl', Label: 'Podlaskie' },
			{ Value: 'locationPlPm', Label: 'Pomorskie' },
			{ Value: 'locationPlSl', Label: 'Śląskie' },
			{ Value: 'locationPlSw', Label: 'Świętokrzyskie' },
			{ Value: 'locationPlWm', Label: 'Warmińsko-mazurskie' },
			{ Value: 'locationPlWp', Label: 'Wielkopolskie' },
			{ Value: 'locationPlZp', Label: 'Zachodniopomorskie' },
		],
		districts: {} as Record<LocationRegion, LocationEntry[]>,
	}),
	getters: {
		foreignCountries: (state) => state.countries.filter((country) => country.Value !== 'locationPl'),
		countriesByCode: (state) => {
			const result = [] as LocationEntry[];
			state.countries.forEach((c) => {
				const countryCode = c.Value.replace('location', '').toUpperCase();
				result.push({ Value: countryCode, Label: `<span class="suggestions-list-hide">${countryCode}</span><span class="dropdown-button-hide">${c.Label}</span>` });
			});
			return result;
		},
	},
	actions: {
		async getDistrict(region:LocationRegion) {
			if (this.districts[region]) { return this.districts[region]; }
			let result = [] as LocationEntry[];
			const url = `/common/dictionary/zip/districts.ofer?zipSearch.idLocationExt=${region}`;
			await fetch(url).then((rsvp) => rsvp.text()).then((rsvp) => {
				const o = (new DOMParser()).parseFromString(rsvp, 'text/html').querySelectorAll('option');
				result = Array.prototype.map.call(o, (r) => ({ Value: r.value, Label: r.innerText.replace('powiat ', '') })) as LocationEntry[];
			});
			this.districts[region] = result;
			return result;
		},
	},
});
